module.exports = __webpack_public_path__ + "static/media/check.a4e6f244.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/svg/check.svg
// module id = 1035
// module chunks = 0